import axios from "axios";

export const getConfigRequest = async () => {
  return axios.get<any>("https://jsonplaceholder.typicode.com/todos");
};
